export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const ARTICLE_SLUG = "basetao-spreadsheet-guide";

export const SITE_NAME = "Basetao Sheet";

export const SITE_URL = import.meta.env.VITE_SITE_URL || "https://basetaosheet.casa";

export const SITE_LOGO =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";